(function(){
  'use strict';

  function announce(message){
    try {
      var live = document.getElementById('a11y-live-region');
      if(!live){
        live = document.createElement('div');
        live.id = 'a11y-live-region';
        live.setAttribute('role','status');
        live.setAttribute('aria-live','polite');
        live.style.position = 'absolute';
        live.style.clipPath = 'inset(50%)';
        live.style.clip = 'rect(1px, 1px, 1px, 1px)';
        live.style.width = '1px';
        live.style.height = '1px';
        live.style.overflow = 'hidden';
        live.style.whiteSpace = 'nowrap';
        document.body.appendChild(live);
      }
      live.textContent = message;
    } catch(e){ /* no-op */ }
  }

  function navigateToProduct(url){
    if(!url) return;
    try { window.location.assign(url); } catch(e) { window.location.href = url; }
  }

  function onActivateCard(event){
    var el = event.target && event.target.closest('[data-product-url]') || event.currentTarget;
    var url = el && el.getAttribute('data-product-url');
    if(!url) return;
    event.preventDefault();
    event.stopPropagation();
    navigateToProduct(url);
  }

  function onKeydownActivate(event){
    if(event.key === 'Enter' || event.key === ' '){
      event.preventDefault();
      onActivateCard(event);
    }
  }

  function init(){
    document.querySelectorAll('[data-product-url]').forEach(function(card){
      // remova atributos antigos se existirem
      card.removeAttribute('data-add-to-cart');
      card.removeAttribute('data-variant-id');
      card.addEventListener('click', onActivateCard, { passive: false });
      card.addEventListener('keydown', onKeydownActivate);
      card.style.cursor = 'pointer';
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function(){
  'use strict';

  function init(root){
    var scroller = root.querySelector('[data-pcm-scroller]');
    if(!scroller) return;
    var list = scroller.querySelector('.pcm__list');
    var prev = root.querySelector('.pcm__arrow--prev');
    var next = root.querySelector('.pcm__arrow--next');

    function getStep(){
      var first = list && list.querySelector('.pcm__item');
      if(!first) return 360;
      var style = window.getComputedStyle(first);
      var width = first.getBoundingClientRect().width;
      var gap = parseFloat(window.getComputedStyle(list).columnGap || window.getComputedStyle(list).gap || '24');
      var mr = parseFloat(style.marginRight || '0');
      var ml = parseFloat(style.marginLeft || '0');
      return Math.ceil(width + ml + mr + gap);
    }

    function updateArrows(){
      if(!list) return;
      var max = list.scrollWidth - scroller.clientWidth;
      var x = scroller.scrollLeft;
      if(prev) prev.disabled = x <= 0;
      if(next) next.disabled = x >= max - 2;
    }

    if(prev){ prev.addEventListener('click', function(){ scroller.scrollBy({left: -getStep(), behavior: 'smooth'}); }); }
    if(next){ next.addEventListener('click', function(){ scroller.scrollBy({left: getStep(), behavior: 'smooth'}); }); }

    scroller.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.pcm').forEach(init);
  });
})();


